import PageCalling from 'src/components/common/PageCalling'
import { useParams } from 'react-router-dom'
import { PramsKeys } from 'src/types/type'
import useAPI from 'src/hooks/useAPI'
import { useRecoilState, useSetRecoilState } from 'recoil'
import {
  PartnerListData,
  TelTypeState,
  TermsListData,
  authKeyState,
  uiData,
} from 'src/recoil/common'
import useMoveScroll from 'src/hooks/useMoveScroll'
import { useEffect } from 'react'
import useIsImgLoad from 'src/hooks/useIsImgLoad'
import PhoneVerification from 'src/components/views/Rop02/PhoneVerification'
import Terms from 'src/components/views/Rop02/Terms'
import JoinSubmit from 'src/components/views/Rop02/JoinSubmit'
import Footer from 'src/components/views/Rop02/Footer'
import useSubmit from 'src/hooks/useSubmit'
import * as S from 'src/styles/styledcomponent/views/Rop02'
import { Rop02Header } from 'src/components/views/Rop02/Rop02Header'
import { ToastPopup } from 'src/components/views/Rop02/ToastPopup'
import { useToastPopup } from 'src/hooks/useToastPopup'
import MVNOModal from 'src/components/common/MVNOModal'
import Banner from 'src/components/views/Rop02/Banner'
import { convertTermsData } from 'src/service/join'
import VulnerableCheckModal from 'src/components/common/VulnerableCheckModal'

const Rop02 = () => {
  const { pcode, authKey, telecom } = useParams<PramsKeys>()
  const submit = useSubmit(pcode ?? '')
  const termsApi = useAPI('requestTermsList')

  const setTermsListData = useSetRecoilState(TermsListData)
  const setPartnerData = useSetRecoilState(PartnerListData)
  const setTelType = useSetRecoilState(TelTypeState)
  const setAuthKey = useSetRecoilState(authKeyState)
  const [
    {
      layoutsInsert: { mainBg },
    },
    setUiData,
  ] = useRecoilState(uiData)
  const { data: getTermsData, isSuccess, isLoading } = termsApi?.useSetQuery({ PCode: pcode })

  const { banner1Ref, banner2Ref } = useIsImgLoad(isSuccess)
  const { onMoveToElement, RefInput } = useMoveScroll(banner2Ref)
  const { isShow, openToast } = useToastPopup()

  const isErrorPartner = getTermsData?.Header.ErrCode === 1011

  useEffect(() => {
    if (isSuccess && !isErrorPartner) {
      const data = getTermsData?.Body
      setTelType(Number(telecom))
      setTermsListData(convertTermsData(data))
      setPartnerData(data?.Partner)
      setUiData(JSON.parse(atob(data?.Partner.UiData)))
    }
    // eslint-disable-next-line
  }, [isSuccess, isErrorPartner, getTermsData?.Body, setPartnerData, setTermsListData, setTelType, setUiData])

  useEffect(() => {
    if (isSuccess) {
      if (pcode === 'pinc_01') {
        setAuthKey(authKey)
      }
    }
  }, [isSuccess, authKey, pcode, setAuthKey])

  useEffect(() => {
    openToast()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Rop02Header />
      <PageCalling active={isLoading} />
      {isSuccess && (
        <S.Rop02Wrap mainBg={mainBg}>
          <Banner banner1Ref={banner1Ref} banner2Ref={banner2Ref} />
          <PhoneVerification
            onMoveToElement={onMoveToElement}
            RefInput={RefInput}
            submit={submit}
            openToast={openToast}
          />
          { !isErrorPartner &&  <Terms /> }
          <JoinSubmit submit={submit} />
          <Footer />
        </S.Rop02Wrap>
      )}
      <ToastPopup isShow={isShow} />
      {submit.isOpen && <MVNOModal submit={submit} />}
      {submit.vulnerableModal.isOpen && <VulnerableCheckModal submit={submit} />}
    </>
  )
}
export default Rop02
